import React, { FC, useContext } from "react";
import { PlayerNumber } from "../../../Components/PlayerNumber";
import { PlayerName } from "../../../Components/PlayerName";
import { Table, Group, Loader, Text, Image, Box } from "@mantine/core";
import { CompetitionContext } from "../../../CompetitionContext.tsx";
import { TeamLogo } from "../../../Components/TeamLogo.tsx";
import { usePlayer } from "../../../hooks/usePlayer.ts";
import { useTopscorer } from "../../../hooks/useTopscorer.ts";
import { getPresentationParamsForOrigin } from "../../../getPresentationParamsForOrigin.ts";

const tdStyle: React.CSSProperties = {
  paddingTop: 15,
  paddingBottom: 15,
  paddingLeft: 30,
  paddingRight: 30,
  color: "white",
};

export const TopscorerFullscreen: FC = () => {
  const competitionId = useContext(CompetitionContext);

  const topscorerData = useTopscorer(competitionId);

  if (!topscorerData.isSuccess) {
    return <></>;
  }

  const scorer = topscorerData.data.topscorer.slice(0, 5);

  return (
    <div
      style={{
        backgroundColor: "black",
        width: 1920,
        height: 1080,
        padding: 50,
      }}
    >
      <Group justify="space-between" align={"start"}>
        <div>
          <Text size="110px" c="white" fw={900}>
            Unsere Topscorer
          </Text>
          <Text
            size="60px"
            c={getPresentationParamsForOrigin().colors.brand[7]}
            mt={30}
          >
            <strong>Alle Topscorer:</strong>{" "}
            {getPresentationParamsForOrigin().appDomain}
          </Text>
        </div>
        <div>
          <Image
            src={getPresentationParamsForOrigin().logo.light}
            height={130}
            maw={600}
            fit="contain"
            alt={getPresentationParamsForOrigin().competitionName}
          />
        </div>
      </Group>

      <Table
        style={{
          marginTop: -30,
          width: "100%",
          fontSize: 64,
          borderCollapse: "collapse",
        }}
      >
        <Table.Thead>
          <Table.Tr
            style={{
              borderBottom: "10px solid white",
            }}
          >
            <Table.Th colSpan={3} style={{ ...tdStyle }}></Table.Th>
            <Table.Th
              style={{ ...tdStyle, textAlign: "center", fontWeight: 700 }}
            >
              T
            </Table.Th>
            <Table.Th
              style={{ ...tdStyle, textAlign: "center", fontWeight: 700 }}
            >
              A
            </Table.Th>
            <Table.Th
              style={{ ...tdStyle, textAlign: "center", fontWeight: 700 }}
            >
              S
            </Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {scorer.map((t) => (
            <PlayerRow
              key={t.playerId}
              playerId={t.playerId}
              position={t.position}
              assists={t.assists}
              goals={t.goals}
            />
          ))}
        </Table.Tbody>
      </Table>
    </div>
  );
};

const PlayerRow: FC<{
  playerId: string;
  position: number;
  assists: number;
  goals: number;
}> = (props) => {
  const { playerId, position, assists, goals } = props;

  const playerData = usePlayer(playerId);

  if (!playerData.isSuccess) {
    return (
      <Table.Tr>
        <Table.Td colSpan={5}>
          <Loader />
        </Table.Td>
      </Table.Tr>
    );
  }

  return (
    <Table.Tr style={{ borderBottom: "5px solid #444444" }}>
      <Table.Td style={{ ...tdStyle, textAlign: "right", width: 100 }}>
        {position}.
      </Table.Td>
      <Table.Td style={{ width: 100 }}>
        <Box w={80}>
          <TeamLogo height={80} teamId={playerData.data?.teamId} />
        </Box>
      </Table.Td>
      <Table.Td style={{ ...tdStyle }}>
        <PlayerName variant={"lastname, firstname"} playerId={playerId} /> (Nr.{" "}
        <PlayerNumber playerId={playerId} />)
      </Table.Td>
      <Table.Td style={{ ...tdStyle, textAlign: "center" }}>{goals}</Table.Td>
      <Table.Td style={{ ...tdStyle, textAlign: "center" }}>{assists}</Table.Td>
      <Table.Td style={{ ...tdStyle, textAlign: "center" }}>
        {goals + assists}
      </Table.Td>
    </Table.Tr>
  );
};
